export const eventKinds = {
  0: "metadata",
  1: "note",
  11: "note",
  5: "deletion",
  7: "reactions",
  6: "reposts",
  30023: "article",
  30024: "draft",
  30004: "curation",
  30005: "curation",
  34235: "video",
  22: "video",
  21: "video",
  20: "picture",
  34236: "video",
  34237: "video view",
  300311: "smart widget",
  30031: "smart widget",
  30033: "smart widget",
  30078: "custom",
  9734: "zaps",
  10000: "mute list",
  10001: "pinning notes",
  10002: "relay list metadata",
  10003: "bookmark list",
  10012: "favorite relays list",
  10015: "interests list",
};
